
import { Component, Output, EventEmitter,Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../services/shared/auth.service';

import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-navbar',
  imports: [FormsModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {

 @Input() notificationCount = 0;
  @Output() locationModal = new EventEmitter<boolean>();
  @Output() genderModal = new EventEmitter<boolean>();
  @Output() settingsModal = new EventEmitter<boolean>();
  @Output() notificationsToggled = new EventEmitter<boolean>();
  @Output() searchResults = new EventEmitter<any[]>();
  @Output() searchTermChange = new EventEmitter<string>();

  searchTerm: string = '';
  searchSubject: Subject<string> = new Subject();

  // notificationCount = 3;
  showNotifications = false;

  constructor(private authService: AuthService) {
    this.searchSubject.pipe(
      debounceTime(300), // wait 300ms after last keystroke
      distinctUntilChanged()
    ).subscribe(query => {
      this.performSearch(query);
    });
  }

  onSearchInput(value: string) {
  this.searchTerm = value;
  this.searchSubject.next(value);
  this.searchTermChange.emit(value); // Emit the value to HomeComponent
}

performSearch(query: string) {
  const token = sessionStorage.getItem('token');
  if (!token || query.trim() === '') {
    this.searchResults.emit([]);
    return;
  }

  this.authService.searchUsers(token, query).subscribe({
    next: async (res: any) => {
      // Fetch user preferences first
      const preferences: any = await this.authService.getUserPreferences(token).toPromise();
      const disliked = preferences.dislikedUsers || [];

      const dislikedIds = new Set(disliked.map((user: any) => user._id));

      // Filter out disliked users
      const filteredUsers = (res.users || []).filter((user: any) => !dislikedIds.has(user._id));

      this.searchResults.emit(filteredUsers);
    },
    error: (err) => {
      this.searchResults.emit([]);
    }
  });
}

closeNavbar() {
  const navbar = document.getElementById('navbarContent');
  if (navbar && navbar.classList.contains('show')) {
    // Bootstrap 5: use collapse instance if available
    // @ts-ignore
    if (window.bootstrap && window.bootstrap.Collapse) {
      // @ts-ignore
      const collapse = window.bootstrap.Collapse.getOrCreateInstance(navbar);
      collapse.hide();
    } else {
      // Fallback: remove the 'show' class
      navbar.classList.remove('show');
    }
  }
}


  toggleLocationModal() {
    this.locationModal.emit(true);
  }

  toggleGenderModal() {
    this.genderModal.emit(true);
  }

  toggleSettingsModal() {
    this.settingsModal.emit(true);
  }

  toggleNotifications() {
    this.showNotifications = !this.showNotifications;
    this.notificationsToggled.emit(this.showNotifications);
  }

  clearStorage() {
    sessionStorage.clear();
    sessionStorage.clear();
    window.location.href = '/';
  }
}